import { useQuery } from '@tanstack/react-query';
import { Badge } from 'src/components/Badge';
import { fetchConversations } from 'src/models/conversation/conversation';

export const MessagesIndicator: React.FC = () => {
  const { data: unreadConversations, isLoading } = useQuery({
    queryKey: ['unreadConversations'],
    queryFn: () =>
      fetchConversations({
        withUser: true,
        sortDir: 'desc',
        page: 1,
        perPage: 50,
        unreadOnly: true,
      }),
    staleTime: 1000 * 60,
  });

  const unreadNumber = unreadConversations?.conversations.length;

  return (
    <Badge
      invisible={isLoading || !unreadNumber}
      badgeContent={unreadNumber}
      color="primary"
      sx={{ mr: 2 }}
    ></Badge>
  );
};
